"use strict";

$(document).ready(function(){
	var crmType = custom.crm;

	window.smsDisclaimer = custom.disclaimer;
	// action network
	if(crmType === 'action-network'){
		if(window.location.pathname === '/'){
			// popup
			$(document).on('web-popup_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('li.form_builder_output').remove();
				$('input#form-email').attr('placeholder', 'Email Address*');
				$('input#form-zip_code').attr('placeholder', 'Zip Code*');
				$('input#form-phone').attr('placeholder', 'Mobile Number');
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				if(smsDisclaimer && smsDisclaimer !== 'false'){
					$('#mobile_opt_in_default').html(smsDisclaimer);
				}
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
				$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
			});
			
			// hero
			$(document).on('web-hero_loaded', function(){
				$('#can_embed_form_inner > h2').remove();
				$('#can_embed_form_inner > h3').remove();
				$('#can_embed_form_inner > h4').remove();
				$('li.form_builder_output').remove();
				$('input#form-email').attr('placeholder', 'Email Address*');
				$('input#form-zip_code').attr('placeholder', 'Zip Code*');
				$('input#form-phone').attr('placeholder', 'Mobile Number');
				$('input[name="subscription[sms_group]"]').prop('checked', true);
				if(smsDisclaimer && smsDisclaimer !== 'false'){
					$('#mobile_opt_in_default').html(smsDisclaimer);
				}
				$('#action_info').remove();
				$('#logo_wrap').remove();
				$('span.international_link-wrap').remove();
				$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
			});

		}

		// media feed cta
		$(document).on('web-ad_loaded', function(){
			$('#can_embed_form_inner > h2').remove();
			$('#can_embed_form_inner > h3').remove();
			$('#can_embed_form_inner > h4').remove();
			$('li.form_builder_output').remove();
			$('input#form-email').attr('placeholder', 'Email Address*');
			$('input#form-zip_code').attr('placeholder', 'Zip Code*');
			$('input#form-phone').attr('placeholder', 'Mobile Number');
			$('input[name="subscription[sms_group]"]').prop('checked', true);
			if(smsDisclaimer && smsDisclaimer !== 'false'){
				$('#mobile_opt_in_default').html(smsDisclaimer);
			}
			$('#action_info').remove();
			$('#logo_wrap').remove();
			$('span.international_link-wrap').remove();
			$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
		});

		// footer cta
		$(document).on('web-footer-cta_loaded', function(){
			$('#can_embed_form_inner > h2').remove();
			$('#can_embed_form_inner > h3').remove();
			$('#can_embed_form_inner > h4').remove();
			$('li.form_builder_output').remove();
			$('input#form-email').attr('placeholder', 'Email Address*');
			$('input#form-zip_code').attr('placeholder', 'Zip Code*');
			$('input#form-phone').attr('placeholder', 'Mobile Number');
			$('input[name="subscription[sms_group]"]').prop('checked', true);
			if(smsDisclaimer && smsDisclaimer !== 'false'){
				$('#mobile_opt_in_default').html(smsDisclaimer);
			}
			$('#action_info').remove();
			$('#logo_wrap').remove();
			$('span.international_link-wrap').remove();
			$('#can_embed_form .core_field #form-zip_code:not(.mb_needed)').css('margin-bottom', '6px!important');
		});
	}

	// media filter
	$('[name="filter"]').change(function(){
		var url = $(this).val();
		window.location.href = url;
	});
	
	// lity
	$('.wp-block-image img').attr('data-lity', '');
	$('.wp-block-media-text__media img').attr('data-lity', '');
	$('.wp-block-timeline img').attr('data-lity', '');
	$('.wp-block-endorse img').attr('data-lity', '');

	// aos
	AOS.init({
		easing: 'ease',
		duration: 1500
	});

	// anchors
	$(function(){
		$('a[href*="#"]:not([href="#"])').click(function(){
			if(location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname){
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				if(target.length){
					$('html, body').animate({
						scrollTop: target.offset().top - 100
					}, 1000);
					return false;
				}
			}
		});
	});
});